<div>
  <div class="tw-font-normal tw-text-gray-500 tw-text-md">{{ label }}</div>
  <div class="tw-flex tw-items-center tw-gap-10" [formGroup]="form">
    @if (!!startIcon) {
      <span
        class="material-icons tw-absolute tw-ml-3 tw-text-[#2a80e4bd] tw-font-extralight"
        >{{ startIcon }}</span
      >
    }
    <input
      [type]="type"
      [readOnly]="disabled"
      [formControlName]="controlName"
      [min]="min"
      [max]="max"
      class="tw-placeholder-neutral-300 {{
        disabled ? 'tw-bg-zinc-100 focus:tw-outline-none' : ''
      }} tw-py-2 {{ startIcon ? 'tw-px-12' : 'tw-px-5' }} tw-border-[2px] {{
        isError ? 'tw-border-red-500' : 'tw-border-zinc-300'
      }}  tw-rounded-md {{ width }} tw-text-md"
      [placeholder]="placeholder"
    />
    @if (!!endIcon) {
      <span class="material-icons -tw-ml-20 tw-text[#2a80e4bd]">{{
        endIcon
      }}</span>
    }
  </div>
  <div
    class="tw-mt-1 tw-text-sm tw-flex tw-items-center tw-gap-1 {{
      isError ? 'tw-text-red-500' : ''
    }}"
  >
    @if (isError) {
      <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
    }
    {{ helperText }}
  </div>
</div>
